import { useState } from "react";
import { Eye, EyeOff, LockKeyhole, Mail } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import { useToast } from "../../context/ToastContext.jsx";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    try {
      const profile = await login(email.trim(), password);
      showToast("Login successful");
      const redirect = profile.role === "admin" ? "/admin/dashboard" : "/user/home";
      navigate(location.state?.from?.pathname || redirect, { replace: true });
    } catch (error) {
      showToast(error.message || "Login failed", "error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-card">
        <div className="login-brand">
          <div className="app-mark">P</div>
          <div>
            <p>PARIKSIT</p>
            <h1>Teachers Time Tracker</h1>
          </div>
        </div>
        <div className="login-copy">
          <h2>Welcome back 👋</h2>
          <p>Login to mark class IN and OUT time.</p>
        </div>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="field has-icon">
            <span>Email</span>
            <Mail size={18} />
            <input
              autoComplete="email"
              inputMode="email"
              placeholder="staff@pariksit.com"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <label className="field has-icon">
            <span>Password</span>
            <LockKeyhole size={18} />
            <input
              autoComplete="current-password"
              placeholder="Enter password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <button
              className="input-action"
              type="button"
              onClick={() => setShowPassword((value) => !value)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
            </button>
          </label>
          <button className="btn btn-primary btn-wide" type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : null}
            Login
          </button>
        </form>
        <p className="login-note">Admin must create your user profile in Firestore before first use.</p>
      </section>
    </main>
  );
}
